// components/ProgramCard.jsx
import ProgramSession from './ProgramSession';

const ProgramCard = ({ program }) => {
  const { name, description, dates, times, venues, isOnline, registrationLinks } = program;

  // Create session objects that combine date, time, venue, etc.
  const sessions = dates.map((date, index) => ({
    date,
    time: times[index],
    venue: venues[index],
    isOnline: isOnline[index],
    registrationLink: registrationLinks[index]
  }));

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <div className="p-4 md:p-5">
        <h3 className="text-lg md:text-xl font-semibold text-blue-800 mb-2">{name}</h3>
        <p className="text-sm md:text-base text-gray-600 mb-3 md:mb-4">{description}</p>

        <div className="space-y-3 md:space-y-4 mt-3 md:mt-4">
          {sessions.map((session, index) => (
            <ProgramSession 
              key={index}
              session={session}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgramCard;